import { http } from '@/core/api';

class ParentApi {
  async getChildren() {
    try {
      const { data } = await http.get('api/parent/children');
      return data;
    } catch {
      return null;
    }
  }

  async getChild(studentSieId) {
    try {
      const { data } = await http.get(`api/parent/children/${studentSieId}`);
      return data;
    } catch {
      return null;
    }
  }

  async deleteChild(studentSieId) {
    try {
      const { data } = await http.delete(`api/parent/children/${studentSieId}`);
      return data;
    } catch {
      return null;
    }
  }
  async getStudentinfo(studentSieId, studentBirthDate, sSNLastDigits) {
    try {
      const { data } = await http.get(
        `api/parent/studentinfo/${studentSieId}/${studentBirthDate}/${sSNLastDigits}`
      );
      return data;
    } catch {
      return null;
    }
  }

  async linkStudentToParentAsync(studentSieId) {
    try {
      const { data } = await http.post(
        `api/parent/linkStudentToParentAsync/${studentSieId}`
      );
      return data;
    } catch {
      return null;
    }
  }

  async DeleteStudentToParentAsync(studentSieId) {
    try {
      const { data } = await http.post(
        `api/parent/DeleteStudentToParentAsync/${studentSieId}`
      );
      return data;
    } catch {
      return null;
    }
  }
}

export { ParentApi };
